<div class="row m-0 h-100 row-container">


    <div class="col-md-2 pe-0 ps-0 section-side-nav h-100 d-none d-md-block">
        <app-admin-sidebar></app-admin-sidebar>
    </div>
    <div class="col-md-10 big-area p-0">

        <div class="wrapperi">

            <div class="col-12 p-0 row m-0">
                <div class="col-1"></div>
                <div class="col-12 mt-4 col-md-10 p-0 input-cover ">
                    <h2>Server käännökset</h2>
                    <button class="btn btn-formed-main-black" data-bs-toggle="modal" data-bs-target="#addModal">Lisää
                        käännös</button>
                    <table class="table table-striped">
                        <thead>
                            <tr>
                                <td>Key</td>
                                <td>FI</td>
                                <td>Muokkaa</td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let data of translations">
                                <td>{{data.key}}</td>
                                <td>{{data.fi}}</td>
                                <td><p (click)="editTranslation(data)"
                                        class="btn btn-formed-main-black" data-bs-toggle="modal" data-bs-target="#editModal">Muokkaa</p></td>

                            </tr>
                        </tbody>
                    </table>
                </div>

                <div class="col-1"></div>
            </div>

        </div>

    </div>

    <div class="modal fade" id="addModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
        aria-hidden="true">
        <div class="modal-dialog modal-xl" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h3 class="modal-title" id="exampleModalLabel">Lisää käännös</h3>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">

                    </button>
                </div>
                <div class="modal-body">
                    <div *ngIf="!isLoading" id="form-container" class="">
                        <form class="flex-row add-form" [formGroup]="add_form" (ngSubmit)="addTranslation()">

                            <!-- Yrityksen nimi ja sukunimi -->
                            <div class="col-12 row m-0 pt-2">

                                <div class="form-floating mb-2  col-12 col-md-12 p-0">
                                    <input type="text" placeholder="a_key" formControlName="a_key" id="a_key"
                                        class="form-control">
                                    <label for="a_key">key</label>
                                </div>

                                <div class="form-floating mb-2  col-12 col-md-12 p-0">
                                    <input type="text" placeholder="a_fi" formControlName="a_fi" id="a_fi"
                                        class="form-control">
                                    <label for="a_fi">Suomeksi</label>
                                </div>

                                <div class="form-floating mb-2  col-12 col-md-12 p-0">
                                    <input type="text" placeholder="a_en" formControlName="a_en" id="a_en"
                                        class="form-control">
                                    <label for="a_en">Englanniksi</label>
                                </div>
                                <div class="form-floating mb-2  col-12 col-md-12 p-0">
                                    <input type="text" placeholder="a_sv" formControlName="a_sv" id="a_sv"
                                        class="form-control">
                                    <label for="a_sv">Ruotsiksi</label>
                                </div>

                            </div>








                            <div class="form-inline mt-2">
                                <div class="form-group mb-2 flex-row">
                                    <button [disabled]="add_form.invalid" class="btn btn-formed-main-black w-100"><i
                                            class="fas fa-sign-in-alt me-2"></i>Tallenna käännös</button>
                                </div>
                            </div>
                        </form>

                    </div>



                </div>
                <div class="modal-footer">
                    <button type="button" class="btn" data-bs-dismiss="modal">Sulje</button>
                </div>
            </div>
        </div>
    </div>

        <div class="modal fade" id="editModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
        aria-hidden="true">
        <div class="modal-dialog modal-xl" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h3 class="modal-title" id="exampleModalLabel">Muokkaa käännöstä</h3>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">

                    </button>
                </div>
                <div class="modal-body">
                    <div *ngIf="!isLoading && currentTranslation" id="form-container" class="" >
                        <form class="flex-row add-form" [formGroup]="edit_form" (ngSubmit)="updateTranslation()">

                            <!-- Yrityksen nimi ja sukunimi -->
                            <div class="col-12 row m-0 pt-2">

                                <p>Key: {{currentTranslation.key}}</p>

                                <div class="form-floating mb-2  col-12 col-md-12 p-0">
                                    <input type="text" placeholder="e_fi" formControlName="e_fi" id="e_fi"
                                        class="form-control">
                                    <label for="e_fi">Suomeksi</label>
                                </div>

                                <div class="form-floating mb-2  col-12 col-md-12 p-0">
                                    <input type="text" placeholder="e_en" formControlName="e_en" id="e_en"
                                        class="form-control">
                                    <label for="e_en">Englanniksi</label>
                                </div>
                                <div class="form-floating mb-2  col-12 col-md-12 p-0">
                                    <input type="text" placeholder="e_sv" formControlName="e_sv" id="e_sv"
                                        class="form-control">
                                    <label for="e_sv">Ruotsiksi</label>
                                </div>

                            </div>

                            <div class="form-inline mt-2">
                                <div class="form-group mb-2 flex-row">
                                    <button [disabled]="edit_form.invalid" class="btn btn-formed-main-black w-100"><i
                                            class="fas fa-sign-in-alt me-2"></i>Tallenna käännös</button>
                                </div>
                            </div>
                        </form>

                    </div>



                </div>
                <div class="modal-footer">
                    <button type="button" class="btn " id="close_edit" data-bs-dismiss="modal">Sulje</button>
                </div>
            </div>
        </div>
    </div>